<template>
  <div class="setup-content contact-info" id="step-2">
    <div class="form-row justify-content-between">
      <div>
        <h3 class="color-darkblue"> Repair Details</h3>
      </div>
      <div v-if="viewAllfields" class="verified-checkbox mr-4">
        <div class="form-group row claim-verified-checkbox pt-7">
          <label for="failure_section_verified" class="control-label claim-mr-2">Verified:</label>
          <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="failure_section_verified"
            id="failure_section_verified" />
        </div>
      </div>
    </div>
    <div class="form-row row-cols-md-4 row-cols-1">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Failure Date:</label>
        </div>
        <div class="input-group">
          <date-picker placeholder="MM/DD/YYYY" id="failure_date" name="failure_date" v-model="failure_date"
            :config="optionsDate" :disabled="disableFailureDate || dealerFieldsDisabled || disableAllFields"></date-picker>
          <label for="failure_date" class="fp-calendar input-calender-icon"></label>
        </div>
        <div class="field-error">{{ failure_date_error_msg }}</div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-3 form-group">
        <div class="example-label">
          <label class="control-label require">Concern:</label>
        </div>
        <textarea v-model="concern" id="concern" class="form-control" rows="5"
          :disabled="(!showCorrectionMadeButton) && (dealerFieldsDisabled || disableAllFields)"></textarea>
        <div class="field-error">{{ concern_error_message }}</div>
      </div>
      <div class="col-12 col-md-3 form-group">
        <div class="example-label">
          <label class="control-label require">Cause:</label>
        </div>
        <textarea v-model="cause" id="cause" class="form-control" rows="5" :disabled="(!showCorrectionMadeButton) && (dealerFieldsDisabled || disableAllFields)"></textarea>
        <div class="field-error">{{ cause_error_msg }}</div>
      </div>
      <div class="col-12 col-md-3 form-group">
        <div class="example-label">
          <label class="control-label require">Correction:</label>
        </div>
        <textarea v-model="correction" id="correction" class="form-control" rows="5" @input="limitWords"
          :disabled="(!showCorrectionMadeButton) && (dealerFieldsDisabled || disableAllFields)"></textarea>
        <div class="field-error">{{ correction_error_message }}</div>
      </div>
    </div>

    <div class="form-row row-cols-md-4 row-cols-1 pb-3">
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Root Cause Part:</label>
        </div>
        <v-select v-model="primary_failed_part" name="primary_failed_part" label="text" :filterable="false"
          :options="componentArr" placeholder="Search Part" class="custom-ci-auto-search" disabled>
          <template slot="no-options">
            Search Part...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ pfp_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Position Code:
            <a v-on:click="showPositionCodeModal()" class="mt-1 a-code-modal">
              Position Code Manual
            </a>
          </label>
        </div>
        <v-select v-model="position_code" id="position" label="text" :options="positionArr"
          @search="onSearchPositionCode" @change="emitPositionCodeToParent" placeholder="Select Position"
          class='custom-ci-auto-search contract-data' :disabled="(!showCorrectionMadeButton) && (dealerFieldsDisabled || disableAllFields)">
          <template slot="no-options">
            Search Position...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ position_error_msg }}</div>
      </div>
      <div class="col form-group">
        <div class="example-label">
          <label class="control-label require">Damage Code:
            <a v-on:click="showDamageCodeModal()" class="mt-1 a-code-modal">
              Damage Code Manual
            </a>
          </label>
        </div>
        <v-select v-model="damage_cause" name="damage_cause" label="text" :filterable="false" :options="reasonArr"
          @search="onSearchReason" placeholder="Search Cause" class="custom-ci-auto-search"
          :disabled="(!showCorrectionMadeButton) && (dealerFieldsDisabled || disableAllFields)">
          <template slot="no-options">
            Search Cause...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ damage_cause_error_msg }}</div>
      </div>
    </div>

    <div class="alert alert-warning hide w-50">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
          aria-hidden="true">&times;</span></button>
    </div>

<!--    position code modal-->
    <div
      class="modal fade"
      id="positionCodeListModal"
      tabindex="1"
      role="dialog"
      aria-labelledby="positionCodeListLabel"
      aria-hidden="true">
        <div
        class="modal-dialog modal-xl"
        role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="positionCodeListLabel">Position Code Manual</h5>
              <button type="button" class="close" v-on:click="hidePositionCodeModal()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-0" v-if="showPositionCode">
              <position-code-list :listOnly='true'/>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" v-on:click="hidePositionCodeModal()">Close</button>
            </div>
          </div>
        </div>
      </div>
<!--    position code modal ends-->

<!--    Damage code modal-->
    <div
      class="modal fade"
      id="damageCodeListModal"
      tabindex="1"
      role="dialog"
      aria-labelledby="damageCodeListLabel"
      aria-hidden="true">
        <div
        class="modal-dialog modal-xl"
        role="document">
          <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="damageCodeListLabel">Damage Code Manual</h5>
            <button type="button" class="close" v-on:click="hideDamageCodeModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0" v-if="showDamageCode">
            <damage-code-list :listOnly='true'/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="hideDamageCodeModal()">Close</button>
          </div>
        </div>
        </div>
    </div>
<!--    Damage code modal ends-->
  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
import moment from 'moment';
import 'moment-timezone';
import PositionCodeList from "@/components/PositionCodeList.vue";
import ReasonList from "../ReasonList.vue";
Vue.component("loading-content", LoadingContent);
Vue.component("position-code-list", PositionCodeList);
Vue.component("damage-code-list",ReasonList)

export default {
  name: "EvFailureTab",
  mixins: [commonMixins],
  props: {
    viewAllfields: {
      type: Boolean,
      default: false
    },
    dealerFieldsDisabled: {
      type: Boolean,
      default: true
    },
    disableAllFields: {
      type: Boolean,
      default: false
    },
    showCorrectionMadeButton: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    componentArr: [],
    disableAll: false,
    component: "",
    failure_date: "",
    repair_date: "",
    current_mfg_sn: "",
    current_model_number: "",
    new_mfg_sn: "",
    new_model_number: "",
    primary_failed_part: "",
    supplier: "",
    cause: "",
    damage_cause: "",
    corrective_action: "",
    part_disposition: "",
    repair_details: "",
    position_code: "",
    positionArr: [],
    failure_date_error_msg: "",
    repair_date_error_msg: "",
    pfp_error_msg: "",
    component_error_msg: "",
    position_error_msg: "",
    cause_error_msg: "",
    damage_cause_error_msg: "",
    corrective_action_error_msg: "",
    optionsDate: {
      format: 'MM/DD/YYYY',
      useCurrent: false,
      widgetPositioning: {
        vertical: 'bottom'
      },
      maxDate: new Date() // just a placeholder
    },
    concern: "",
    correction: "",
    reasonArr: [],
    correction_error_message: "",
    section_verified: false,
    repairDetailId: '',
    concern_error_message: "",
    isEdit: false,
    disableFailureDate: true,
    isfirstLoad: false,
    initialFailureData: '',
    currentFailureData: '',
    showPositionCode: false,
    showDamageCode: false,
  }),
  watch: {
    positionArr(value) {
      if (this.isfirstLoad) {
        this.isfirstLoad = false;
        this.onSearchReason('43', 'loading');
      }
    }

  },
  mounted() {
    var path = window.location.pathname;
    var segments = path.split("/");
    if (!segments[3]) {
      this.isfirstLoad = true;
      this.onSearchPositionCode('54201', 'loading');
    } else {
      this.isEdit = true;
    }
    const damageCodeModal = document.getElementById('damageCodeListModal');
    $(damageCodeModal).on('hidden.bs.modal', () => {
      // Handle modal close here
      this.showDamageCode = false;
    });

    const positionCodeModal = document.getElementById('positionCodeListModal');
    $(positionCodeModal).on('hidden.bs.modal', () => {
      // Handle modal close here
      this.showPositionCode = false;
    });
  },
  methods: {
    gotoNext: function (flag) {
      var self = this;
      // var success = self.validateFailureFields();
      // if (success) {
      self.emitDataToParent();
      self.gotoNextStepMixins(flag);
      // }
    },
    gotoBack: function (flag) {
      var self = this;
      self.gotoBackStepMixins(flag);
    },
    onSearchComponent(search, loading) { // function to handle the searchable drop down of parts
      var self = this;
      if (search.length > 2) {

        if (typeof loading === 'function') {
          loading(true); // Call the loading function if it's a function
        } else {
          self.loading = true;
        }
        self.searchField(loading, search, 'component', '');
      }
    },
    onSearchPositionCode(search, loading) {
      var self = this;
      if (search.length > 2) {
        if (typeof loading === 'function') {
          loading(true); // Call the loading function if it's a function
        } else {
          self.loading = true;
        }
        self.searchField(loading, search, 'failed_part_positions', '');
      }
    },
    onSearchReason(search, loading) {
      var self = this;
      if (search.length > 0) {
        if (typeof loading === 'function') {
          loading(true); // Call the loading function if it's a function
        } else {
          self.loading = true;
        }
        self.searchField(loading, search, 'reason', '');
      }
    },
    validateFailureFields() {
      var self = this;
      self.clearErrorMessages();
      var success = true;

      if (self.failure_date == null || self.failure_date == "") {
        self.failure_date_error_msg = "Failure Date Required";
        success = false;
      }
      if (self.concern == null || self.concern == '') {
        self.concern_error_message = 'Concern Required';
        success = false;
      }
      if (self.cause == null || self.cause == "") {
        self.cause_error_msg = "Cause Required";
        success = false;
      }
      if (self.correction == null || self.correction == "") {
        self.correction_error_message = "Correction Required";
        success = false;
      }
      if (self.primary_failed_part == null || self.primary_failed_part == "") {
        self.pfp_error_msg = "Root Cause Part Required";
        success = false;
      }
      if (self.position_code == null || self.position_code == "") {
        self.position_error_msg = "Position Code Required";
        success = false;
      }
      if (self.damage_cause == null || self.damage_cause == "") {
        self.damage_cause_error_msg = "Damage Code Required";
        success = false;
      }

      return success;
    },
    clearErrorMessages() {
      var self = this;
      self.failure_date_error_msg = '';
      self.concern_error_message = '';
      self.cause_error_msg = '';
      self.correction_error_message = '';
      self.pfp_error_msg = '';
      self.position_error_msg = '';
      self.damage_cause_error_msg = '';
    },
    emitDataToParent() {
      var self = this;
      const dataToSend = {
        failure_date: self.failure_date,
        concern: self.concern,
        cause: self.cause,
        correction: self.correction,
        root_cause_part: self.primary_failed_part,
        position_code: self.position_code,
        damage_code: self.damage_cause,
        verified: self.section_verified,
        repairDetailId: self.repairDetailId
      };
      self.$emit("send-failure-data-to-parent", dataToSend);
    },
    emitPositionCodeToParent() {
      var self = this;
      var posCode = null;
      if (self.position_code != null && self.position_code != "") {
        posCode = self.position_code.text;
      }

      const dataToSend = {
        position_code: posCode
      };

      self.$emit("send-position-code-to-parent", dataToSend);
    },
    getFailureData(failureData) {
      var self = this;
      if (failureData.failed_item_id === "") {
        self.primary_failed_part = null;
      } else {
        self.primary_failed_part = { "value": failureData.failed_item_id, "text": failureData.failed_item_text };
      }
      self.failure_date = failureData.failure_date;
      self.repair_date = failureData.repair_date;
      self.current_mfg_sn = failureData.current_mfg_sn;
      // self.current_model_number = failureData.current_model_number;
      self.new_mfg_sn = failureData.new_mfg_sn;
      // self.new_model_number = failureData.new_model_number;
      // self.primary_failed_part = failureData.primary_failed_part;
      self.supplier = failureData.supplier;
      if (failureData.poistion_value === "") {
        self.position_code = null;
      } else {
        self.position_code = { "value": failureData.position_value, "text": failureData.position_text };
      }
      self.cause = failureData.probable_cause;
      // self.corrective_action = failureData.corrective_action;
      self.part_disposition = failureData.failed_part_disposition;
      self.repair_details = failureData.repair_details;
      self.damage_cause = failureData.damage_cause;
      self.concern = failureData.concern;
      self.correction = failureData.correction;
    },
    limitWords(event) {
      var self = this;
      var wordCount = self.correction.split(/\s+/).filter(word => word.length > 0).length;
      if (wordCount > 3000) {
          event.preventDefault();
          self.correction_error_message = "Correction cannot be more than 3000 words!";
          self.correction = self.correction.split(/\s+/).slice(0, 3000).join(' ');
      }
    },
    getRootCausePartFromParent(rootCausePart) {
      if (rootCausePart[0] == 'no-parts') {
        if (rootCausePart[1]) {
          this.primary_failed_part = {
            text: 'N/A',
            value: 'N/A'
          };
        } else {
          this.primary_failed_part = null;
        }
      } else {
        this.primary_failed_part = rootCausePart[0];
      }
    },
    getDataFromParent(repairDetailData) {
      this.failure_date = moment(repairDetailData.failure_date, 'MM/DD/YYYY').toDate();
      this.concern = repairDetailData.concern;
      this.cause = repairDetailData.cause;
      this.correction = repairDetailData.correction;
      if (repairDetailData.failed_part_position != null) {
        var positionCodeText = repairDetailData.failed_part_position.code + ' | ' + repairDetailData.failed_part_position.system;
        this.position_code = {
          text: positionCodeText,
          value: repairDetailData.failed_part_position.id
        };
      }

      if (repairDetailData.reason != null) {
        var damageCauseText = repairDetailData.reason.code + ' | ' + repairDetailData.reason.name;
        this.damage_cause = {
          text: damageCauseText,
          value: repairDetailData.reason.id
        };
      }

      if (repairDetailData.failed_part_position == null && repairDetailData.reason == null ) {
        this.isfirstLoad = true;
        this.onSearchPositionCode('54201', 'loading');
      } else if (repairDetailData.failed_part_position != null && repairDetailData.reason == null ){
        this.onSearchReason('43', 'loading');
      } else if (repairDetailData.failed_part_position == null && repairDetailData.reason != null ){
        this.onSearchPositionCode('54201', 'loading');
      }



      this.section_verified = (repairDetailData.verified == 0) ? false : true;
      this.repairDetailId = repairDetailData.id;

      if (repairDetailData.root_cause_part != null) {
        if (repairDetailData.root_cause_part) {
          this.primary_failed_part = {
            text: repairDetailData.root_cause_part.vendor_item_number,
            value: repairDetailData.root_cause_part.id
          }
        } else {
          this.primary_failed_part = {
            text: 'N/A',
            value: 'N/A'
          };
        }
      }
      this.$nextTick(() => {
        this.populateInitialFailureData(true);
      });
    },
    populateInitialFailureData(flag){
      if(flag) {
        setTimeout(() => {
          this.setInitialValue(flag);
        }, 500);
      } else {
        return this.setInitialValue(flag);
      }
    },
    setInitialValue(flag){
      const failureData = JSON.stringify({
          failure_date: this.failure_date,
          concern: this.concern,
          cause: this.cause,
          correction: this.correction,
          root_cause_part: this.primary_failed_part,
          position_code: this.position_code,
          damage_code: this.damage_cause,
          verified: this.section_verified,
          repairDetailId: this.repairDetailId
      });

      if (flag) {
        this.initialFailureData = '';
        this.initialFailureData = failureData;
      } else {
        this.currentFailureData = '';
        this.currentFailureData = failureData;

        return this.initialFailureData !== this.currentFailureData;
      }
    },
    clearAllFields() {
      var self = this;
      self.clearErrorMessages();

      self.section_verified = false;
      self.failure_date = '';
      self.concern = '';
      self.cause = '';
      self.correction = '';
      self.primary_failed_part = '';
      self.position_code = '';
      self.damage_cause = '';
    },
    getRepairDate(date) {
      if (date == '' || date == null) {
        this.failure_date = '';
        this.disableFailureDate = true;
      } else {
        this.disableFailureDate = false;
        this.optionsDate.maxDate = date;
      }
      if (date < this.failure_date) {
        this.failure_date = "";
      }
    },
    showPositionCodeModal(){
      this.showPositionCode = true;
      $("#positionCodeListModal").modal('show');
    },
    hidePositionCodeModal(){
      this.showPositionCode = false;
      $("#positionCodeListModal").modal('hide');
    },
    showDamageCodeModal(){
      this.showDamageCode = true;
      $("#damageCodeListModal").modal('show');
    },
    hideDamageCodeModal(){
      this.showDamageCode = false;
      $("#damageCodeListModal").modal('hide');
    },
  },
}
</script>
<style scoped>
.a-code-modal{
  cursor: pointer;
  font-size: 16px;
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvFailureTab.vue